import { Pipe, PipeTransform } from '@angular/core';
import { format, parseISO, isValid } from 'date-fns';
import { ru } from 'date-fns/locale';

@Pipe({
  name: 'birthdayFormat',
})
export class BirthdayFormatPipe implements PipeTransform {
  transform(dateOfBirth: string | undefined | null): string | null {
    if (!dateOfBirth) {
      return null;
    }

    const date = parseISO(dateOfBirth);

    if (!isValid(date)) {
      return null;
    }

    const formatted = format(date, 'd MMMM', { locale: ru });

    return `День Рождения: ${formatted}`;
  }
}
